import { ArrowRightIcon, InformationCircleIcon } from "@heroicons/react/24/solid";

const ClientReviewBanner = ({ count, onClick }) => {
    if (!(count > 0)) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            className="mb-6 flex w-full items-center justify-between gap-4 rounded-lg border border-amber-400 bg-amber-100 p-4 text-left shadow-sm transition hover:border-amber-500 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
            aria-label={`${count} ${count === 1 ? "client needs" : "clients need"} Semiannual Client Review. Review clients.`}
        >
            <span className="flex min-w-0 items-start gap-3">
                <InformationCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-amber-700" />
                <span>
                    <span className="block font-semibold text-slate-900">
                        {count} {count === 1 ? "client needs" : "clients need"}{" "}
                        Semiannual Client Review
                    </span>
                    <span className="mt-0.5 block text-sm text-slate-600">
                        Review clients with no recent activity.
                    </span>
                </span>
            </span>
            <span className="inline-flex shrink-0 items-center gap-2 text-sm font-semibold text-amber-800">
                Review clients
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
            </span>
        </button>
    );
};

export default ClientReviewBanner;
